import React, { Component } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Offsidebar from "./Offsidebar";
import Footer from "./Footer";
import ChatBot from "../../Roldan/Chatbot";
import Swal from "sweetalert2";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Services } from "../Services";

// Roles
// 1	"Administrador"
// 2	"Cliente"
// 3	"Roldan"
// 4	"Roldan SU"
// 5	"Gestor Documental"
class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      showWelcomeMessage: false,
    };
  }

  async componentDidMount() {
    const token = localStorage.getItem("token");
    try {
      // const oauthData =
      await axios.get(`${Services.ADMIN.path}/oauth/validate?token=${token}`);

      const { Alert, PasswordExpired, tokenExpired } =
        this.props.SideBarConfig.passwordExpiredData;

      if (Alert && !this.state.showWelcomeMessage && !tokenExpired) {
        Swal.fire({
          title: "¡Importante!",
          text: `Tu contraseña caduca en ${PasswordExpired} días ¿Quieres cambiarla ahora?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          // allowOutsideClick: false,
          // allowEscapeKey: false,
          customClass: {
            confirmButton: "custom-confirm-button",
            cancelButton: "custom-cancel-button",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.props.history.push("/my-perfil");
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log("El usuario no quiere cambiar la contraseña.");
          }
        });

        this.setState({ showWelcomeMessage: true });
      }
    } catch (error) {}
  }

  render() {
    return (
      <div className="wrapper">
        <Header
          changeProps={() => {
            this.setState({ key: Math.random() });
          }}
        />
        <Sidebar _userconfig={{ ...this.props }} />
        <Offsidebar />
        <section className="section-container" key={this.state.key}>
          {this.props.children}
        </section>
        {this.props.SideBarConfig.RoleId === "1" ||
        this.props.SideBarConfig.RoleId === "2" ||
        this.props.SideBarConfig.RoleId === "3" ||
        this.props.SideBarConfig.RoleId === "4" ? (
          <ChatBot />
        ) : (
          ""
        )}
        <Footer />
      </div>
    );
  }
}

export default withRouter(Base);
